import React, { useEffect, useState } from 'react';
import { Spin, Timeline, Typography } from 'antd';
import { getRecordTimeline } from '../services/api';
import RecordLink from './RecordLink';

const { Text } = Typography;

interface RecordTimelineProps {
  recordId: string;
  projectId?: string | null;
}

const GREEN = ['CLOSED', 'APPROVED', 'ACCEPTED', 'RESOLVED'];
const RED = ['REJECTED'];
const ORANGE = ['ESCALATED'];

const colorFor = (status?: string) => {
  const s = (status || '').toUpperCase();
  if (GREEN.includes(s)) return 'green';
  if (RED.includes(s)) return 'red';
  if (ORANGE.includes(s)) return 'orange';
  return 'blue';
};

// Chronological trail of everything that has happened to a record, from creation to closure.
const RecordTimeline: React.FC<RecordTimelineProps> = ({ recordId, projectId }) => {
  const [events, setEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setFailed(false);
    getRecordTimeline(recordId)
      .then((res) => { if (!cancelled) setEvents(res.data.events || []); })
      .catch(() => { if (!cancelled) setFailed(true); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [recordId]);

  if (loading) return <Spin size="small" />;
  if (failed) return <Text type="danger">Could not load the timeline.</Text>;
  if (events.length === 0) return <Text type="secondary">No activity recorded yet.</Text>;

  return (
    <Timeline
      items={events.map((ev, i) => ({
        key: i,
        color: colorFor(ev.status),
        children: (
          <>
            <div>
              <Text strong>{ev.label}</Text>
              {ev.record_id && ev.record_id !== recordId && (
                <> — <RecordLink recordId={ev.record_id} recordType={ev.record_type} projectId={projectId} /></>
              )}
            </div>
            <div style={{ fontSize: 12, color: '#888' }}>
              {new Date(ev.at).toLocaleString('en-IN')}{ev.by ? ` · ${ev.by}` : ''}
            </div>
            {ev.detail && <div style={{ fontSize: 12 }}>{ev.detail}</div>}
          </>
        ),
      }))}
    />
  );
};

export default RecordTimeline;
